import { defineStore } from 'pinia'
import { type Ref, ref } from 'vue'

export const useHelpdeskStore = defineStore('helpdesk', () => {
  // Store customer's partnerProxyId for helpdesk context
  const customerPartnerProxyId: Ref<string | null> = ref(null)

  function setCustomerPartnerProxyId(ppId: string | null) {
    customerPartnerProxyId.value = ppId
  }

  function getCustomerPartnerProxyId(): string | null {
    return customerPartnerProxyId.value
  }

  function clearCustomerPartnerProxyId() {
    customerPartnerProxyId.value = null
  }

  return {
    customerPartnerProxyId,
    setCustomerPartnerProxyId,
    getCustomerPartnerProxyId,
    clearCustomerPartnerProxyId
  }
})
